import { useMutation } from '@tanstack/react-query'

import queryClient from 'api/queryClient'

import { useProjectInfo } from 'hooks/useProjectInfo/useProjectInfo'

import { JobSummaryId, useGetJobSummariesQueryKey } from '../useGetJobSummaries'
import { useSpringClient } from '../useSpringClient/useSpringClient'
import { renameJobApi } from './renameJobApi'

export interface RenameJobRequest {
  jobId: JobSummaryId
  newJobId: JobSummaryId
}

export const useRenameJob = () => {
  const { projectId, branchId: branchName } = useProjectInfo()
  const client = useSpringClient()
  const jobSummariesQueryKey = useGetJobSummariesQueryKey()

  return useMutation(
    async ({ newJobId, jobId }: RenameJobRequest) => {
      return renameJobApi({
        client,
        projectId,
        branchName,
        jobId,
        newJobId
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(jobSummariesQueryKey)
      }
    }
  )
}
